import type { ReactNode } from 'react'

/**
 * `div.astack` → `field-stack` (process/08-COMPONENT-CATALOGUE.md). "A vertical run of `field`s
 * inside an `auth-card`." gap 14px → --sp-7 (0 delta); margin-bottom 16px → --sp-8 (0 delta).
 */
export function FieldStack({ children }: { children: ReactNode }) {
  return (
    <div data-cmp="field-stack" className="flex flex-col gap-7 mb-8">
      {children}
    </div>
  )
}
